import React from 'react';
import { styled } from '@mui/material';
import { Grid, Tooltip } from '@mui/material';
import { TextCellProps } from './TextCell.props';

const PREFIX = 'TextCell';

const classes = {
  tooltip: `${PREFIX}-tooltip`,
};

const StyledGrid = styled(Grid)(() => ({
  [`& .${classes.tooltip}`]: {
    margin: '0px',
  },
}));

const CustomTooltip = Tooltip;

const TextCell = (props: TextCellProps) => {
  const { children, shouldDisplayTooltip, textRef } = props;

  return (
    <StyledGrid component="span" className="text-cell">
      <Grid component="span" ref={textRef}>
        {shouldDisplayTooltip ? (
          <CustomTooltip
            placement="bottom-end"
            title={children?.toString() ?? ''}
            classes={{
              tooltip: classes.tooltip,
            }}>
            <Grid component="span">{children}</Grid>
          </CustomTooltip>
        ) : (
          <Grid component="span">{children}</Grid>
        )}
      </Grid>
    </StyledGrid>
  );
};

export default TextCell;
